import { IconProps } from "./types";
import React from "react";

export const PinIcon = ({
  className,
  fill = "currentColor",
  width = 10,
  height = 11,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 13 13"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M3.11608 1.76034C3.11608 1.38582 3.41854 1.08325 3.79291 1.08325H9.20757C9.58195 1.08325 9.88441 1.38582 9.88441 1.76034C9.88441 2.13485 9.58195 2.43742 9.20757 2.43742H8.58362L8.82474 5.57316C9.60098 5.99422 10.2144 6.69881 10.5062 7.5769L10.5274 7.64038C10.5972 7.84774 10.5612 8.07414 10.4343 8.24976C10.3074 8.42538 10.1023 8.53117 9.88441 8.53117H3.11608C2.89822 8.53117 2.69517 8.42749 2.56615 8.24976C2.43713 8.07202 2.40329 7.84562 2.47309 7.64038L2.49424 7.5769C2.78612 6.69881 3.3995 5.99422 4.17574 5.57316L4.41687 2.43742H3.79291C3.41854 2.43742 3.11608 2.13485 3.11608 1.76034ZM5.82341 9.20825H7.17707V11.2395C7.17707 11.614 6.87461 11.9166 6.50024 11.9166C6.12587 11.9166 5.82341 11.614 5.82341 11.2395V9.20825Z"
      fill={fill}
    />
  </svg>
);
